import request from '@/api'

// 用户相关API
export const userApi = {
  // 用户登录
  login(data) {
    return request({
      url: '/login',
      method: 'post',
      data
    })
  },

  // 发送验证码
  sendCode(data) {
    return request({
      url: '/send_code',
      method: 'post',
      data
    })
  },


  // 获取用户信息
  getUserInfo() {
    return request({
      url: "/account/info",
      method: "get",
    });
  },

  // 用户登出
  logout() {
    return request({
      url: "/logout",
      method: "get",
    });
  },
};